export default __webpack_public_path__ + "static/atlas_sc-b595e2c889085a5b80ed7fc4929eae69.png";